export const ACTIVE_FILTER_DELIMITER = '~';
export interface FilterInterface<T> {
  displayName?: string;
  value: string;
  filterFunction: (object: T) => boolean;
}
export interface IFilter<T> {
  groupName: string;
  allowedMultipleFilters: boolean;
  filterGroup: FilterInterface<T>[];
}
export type ActiveFilters = Set<string>;
export function getFilteredData<T>(data: T[], filters: IFilter<T>[], activeFilters: ActiveFilters) {
  const groupWiseActiveFilters: {
    [key: string]: string[];
  } = {};
  activeFilters.forEach((activeFilter) => {
    const [filterGroup, filterName] = activeFilter.split(ACTIVE_FILTER_DELIMITER);
    if (groupWiseActiveFilters[filterGroup] === undefined) {
      groupWiseActiveFilters[filterGroup] = [];
    }
    groupWiseActiveFilters[filterGroup].push(filterName);
  });

  const filteredData = data.filter((row) => {
    return Object.entries(groupWiseActiveFilters).every(([filterGroup, activeFiltersInGroup]) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const filterGroupData = filters.find((fg) => fg.groupName === filterGroup)!;
      const filterFunctionsInGroup: FilterInterface<T>[] = activeFiltersInGroup.map((filterName) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return filterGroupData.filterGroup.find((f) => {
          return f.value === filterName;
        })!;
      });
      return filterFunctionsInGroup.some((fn) => fn.filterFunction(row));
    });
  });
  // const filterfunctionAcrossGroups = filters.map((filter) =>
  //   filter.filterGroup.filter(
  //     (f) => activeFilters.includes(f.value) && f.filterFunction
  //   )
  // );
  // let res = data;
  // filterfunctionAcrossGroups.map((filterFunctionInOneGroup) => {
  //   if (filterFunctionInOneGroup.length > 0) {
  //     res = res.filter((d) =>
  //       filterFunctionInOneGroup.some((filter) => filter.filterFunction(d))
  //     );
  //   }
  // });
  return filteredData;
  // return {
  //   // setActiveFilters,
  //   activeFilters,
  // };
}
